import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import './assets/shared.css'

import axios from 'axios'

Vue.config.productionTip = false
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,HEAD,OPTIONS,POST,PUT';
//axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Content-Type, Authorization';
axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';

// --- API CONFIGURATION ---
// Se configura vía .env (VUE_APP_API_URL) o se puede forzar aquí:
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'https://localhost:7253/';

console.log("%c--- AXIOS DEBUG ---", "background: #1976D2; color: white; font-weight: bold;");
console.log("Active BaseURL:", axios.defaults.baseURL);
console.log("-------------------");
// --------------------------


new Vue({
  router,
  store,
  vuetify,
  axios,
  render: function (h) { return h(App) }
}).$mount('#app')

